import React, { useState } from 'react';
import CloseIcon from '../../../../assets/icons/close.svg';
import { AuthenticatedPUTRequest } from '../../../../utils';
import { allDistricts, statesInUrdu } from '../../../../constants/constants';
import { isEmptyObject } from '../../../../utils';

const EditTeacherAddressDetailsModal = (props) => {
    const { teacher, setState, onError, onClose } = props;
    // set districts list
    const getDistrictList = (stateName) => {
        if (stateName === 'پنجاب' || stateName === '') {
            const { punjab } = allDistricts;
            return punjab;
        } else if (stateName === 'آزاد کشمیر') {
            const { azadKashmir } = allDistricts;
            return azadKashmir;
        } else if (stateName === 'بلوچستان') {
            const { blochistan } = allDistricts;
            return blochistan;
        } else if (stateName === 'سندھ') {
            const { sindh } = allDistricts;
            return sindh;
        } else if (stateName === 'خیبر پختونخوا') {
            const { khabarPakhtonKhawan } = allDistricts;
            return khabarPakhtonKhawan;
        } else if (stateName === 'گلگت بلتستان') {
            const { gilgitBaltistan } = allDistricts;
            return gilgitBaltistan;
        }
    };
    const [loading, setLoading] = useState(false);
    const [isAddressSame, setAddressSame] = useState(false);
    const [addressInformation, setAddressInformation] = useState(teacher);

    const updateTeacherAddress = async (id, values) => {
        setLoading(true);
        try {
            const { data, success } = await AuthenticatedPUTRequest(`teachers/${id}`, {
                teacher: values,
            });
            setLoading(false);
            onClose();
            if (!success) {
                onError('براہ کرم دوبارہ کوشش کریں۔');
            } else {
                setState(data);
            }
        } catch (error) {
            setLoading(false);
            onError('براہ کرم دوبارہ کوشش کریں۔');
        }
    };

    const onUpdate = () => {
        var updatedInformation = {};
        for (let key in addressInformation) {
            if (addressInformation[key] !== teacher[key]) {
                updatedInformation[key] = addressInformation[key];
            }
        }
        if (!isEmptyObject(updatedInformation)) {
            updateTeacherAddress(addressInformation.id, updatedInformation);
        } else {
            onClose();
        }
    };

    return (
        <div
            className='flex column justifyCenter alignCenter'
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1000,
                background: 'rgba(0,0,0,0.7)',
            }}
        >
            <div
                style={{
                    background: '#ffffff',
                    height: 485,
                    maxHeight: 485,
                    width: 980,
                    borderRadius: 8,
                }}
            >
                <div className='h-100 w-100' style={{ overflow: 'auto', position: 'relative' }}>
                    <div
                        className='flex justifyBetween alignCenter w-100'
                        style={{
                            borderBottom: '1px solid #E0E0E0',
                            padding: '20px 16px 8px',
                            height: 72,
                        }}
                    >
                        <h2 className='flex alignCenter w-100' style={{ color: '#009688' }}>
                            پتا کی معلومات ترمیم کریں
                        </h2>

                        <img
                            src={CloseIcon}
                            alt='close_icon'
                            height={32}
                            width={32}
                            onClick={props.onClose}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>

                    <div
                        className='flex column justifyCenter alignCenter urdu'
                        style={{ padding: 20 }}
                    >
                        <div className='flex column w-100'>
                            {/* present address */}
                            <div className='flex justifyBetween alignCenter'>
                                {/* province list */}
                                <div className='form-container urdu'>
                                    <label htmlFor='current_state'>
                                        اپنا صوبہ منتخب کریں
                                        <span className='mlr required'>*</span>
                                    </label>
                                    <select
                                        name='current_state'
                                        disabled={isAddressSame}
                                        defaultValue={addressInformation['current_state']}
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setAddressInformation({
                                                    ...addressInformation,
                                                    current_state: e.target.value,
                                                });
                                                getDistrictList(e.target.value);
                                            } else {
                                                setAddressInformation({
                                                    ...addressInformation,
                                                    current_state: '',
                                                });
                                                getDistrictList('');
                                            }
                                        }}
                                    >
                                        {statesInUrdu.map((state, index) => (
                                            <option value={state} key={index + 1}>
                                                {state}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                {/* district list */}
                                <div className='form-container urdu'>
                                    <label htmlFor='current_city'>
                                        اپنا ضلع منتخب کریں
                                        <span className='mlr required'>*</span>
                                    </label>
                                    <select
                                        name='current_city'
                                        disabled={isAddressSame}
                                        value={addressInformation['current_city']}
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setAddressInformation({
                                                    ...addressInformation,
                                                    current_city: e.target.value,
                                                });
                                            } else {
                                                setAddressInformation({
                                                    ...addressInformation,
                                                    current_city: '',
                                                });
                                            }
                                        }}
                                    >
                                        {getDistrictList(teacher.current_state).map(
                                            (district, index) => (
                                                <option value={district} key={index + 1}>
                                                    {district}
                                                </option>
                                            ),
                                        )}
                                    </select>
                                </div>
                                {/* remaining address */}
                                <div className='form-container urdu'>
                                    <label htmlFor='current_address'>
                                        بقیہ موجودہ پتا ( بغیر صوبہ اور ضلع )
                                        <span className='mlr required'>*</span>
                                    </label>
                                    <input
                                        type='text'
                                        name='current_address'
                                        disabled={isAddressSame}
                                        value={addressInformation['current_address']}
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setAddressInformation({
                                                    ...addressInformation,
                                                    current_address: e.target.value,
                                                });
                                            } else {
                                                setAddressInformation({
                                                    ...addressInformation,
                                                    current_address: '',
                                                });
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                            {/* check if present and permanent address is exact same */}
                            <div
                                className='flex justifyBetween alignCenter'
                                style={{ margin: '20px 0 0' }}
                            >
                                <div className='form-container urdu'>
                                    <div className='flex justifyStart alignCenter'>
                                        <input
                                            style={{
                                                height: 36,
                                                width: 36,
                                                cursor: 'pointer',
                                            }}
                                            type='checkbox'
                                            checked={isAddressSame}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    if (
                                                        addressInformation.current_state !== '' &&
                                                        addressInformation.current_city !== '' &&
                                                        addressInformation.current_address !== ''
                                                    ) {
                                                        setAddressInformation({
                                                            ...addressInformation,
                                                            permanent_state:
                                                                addressInformation.current_state,
                                                            permanent_city:
                                                                addressInformation.current_city,
                                                            permanent_address:
                                                                addressInformation.current_address,
                                                        });
                                                        setAddressSame(e.target.checked);
                                                    }
                                                } else {
                                                    setAddressInformation({
                                                        ...addressInformation,
                                                        permanent_state: teacher.permanent_state,
                                                        permanent_city: teacher.permanent_city,
                                                        permanent_address:
                                                            teacher.permanent_address,
                                                    });
                                                    setAddressSame(e.target.checked);
                                                }
                                            }}
                                        />
                                        <label
                                            htmlFor='addressCheck'
                                            style={{ marginRight: 16, marginTop: 20 }}
                                        >
                                            کیا مستقل پتا ہی موجودہ پتا ہے ؟ جیسا کہ اوپر دیا گیا ہے
                                        </label>
                                    </div>
                                </div>
                            </div>

                            {/* permanent address */}
                            <div className='flex justifyBetween alignCenter'>
                                {/* province list */}
                                <div className='form-container urdu'>
                                    <label htmlFor='permanent_state'>
                                        اپنا صوبہ منتخب کریں
                                        <span className='mlr required'>*</span>
                                    </label>
                                    <select
                                        name='permanent_state'
                                        disabled={isAddressSame}
                                        defaultValue={addressInformation['permanent_state']}
                                        onChange={(e) => {
                                            if (isAddressSame) {
                                                setAddressInformation({
                                                    ...addressInformation,
                                                    permanent_state:
                                                        addressInformation.current_state,
                                                });
                                            } else {
                                                if (e.target.value.length > 0) {
                                                    setAddressInformation({
                                                        ...addressInformation,
                                                        permanent_state: e.target.value,
                                                    });
                                                    getDistrictList(e.target.value);
                                                } else {
                                                    setAddressInformation({
                                                        ...addressInformation,
                                                        permanent_state:
                                                            addressInformation.current_state,
                                                    });
                                                    getDistrictList('');
                                                }
                                            }
                                        }}
                                    >
                                        {statesInUrdu.map((state, index) => (
                                            <option value={state} key={index + 1}>
                                                {state}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                {/* district list */}
                                <div className='form-container urdu'>
                                    <label htmlFor='permanent_city'>
                                        اپنا ضلع منتخب کریں
                                        <span className='mlr required'>*</span>
                                    </label>
                                    <select
                                        name='permanent_city'
                                        disabled={isAddressSame}
                                        value={addressInformation['permanent_city']}
                                        onChange={(e) => {
                                            if (isAddressSame) {
                                                setAddressInformation({
                                                    ...addressInformation,
                                                    permanent_city: addressInformation.current_city,
                                                });
                                            } else {
                                                if (e.target.value.length > 0) {
                                                    setAddressInformation({
                                                        ...addressInformation,
                                                        permanent_city: e.target.value,
                                                    });
                                                } else {
                                                    setAddressInformation({
                                                        ...addressInformation,
                                                        permanent_city:
                                                            addressInformation.current_city,
                                                    });
                                                    getDistrictList('');
                                                }
                                            }
                                        }}
                                    >
                                        {getDistrictList(teacher.current_state).map(
                                            (district, index) => (
                                                <option value={district} key={index + 1}>
                                                    {district}
                                                </option>
                                            ),
                                        )}
                                    </select>
                                </div>
                                {/* remaining address */}
                                <div className='form-container urdu'>
                                    <label htmlFor='permanent_address'>
                                        بقیہ مستقل پتا ( بغیر صوبہ اور ضلع )
                                        <span className='mlr required'>*</span>
                                    </label>
                                    <input
                                        type='text'
                                        name='permanent_address'
                                        disabled={isAddressSame}
                                        value={addressInformation['permanent_address']}
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setAddressInformation({
                                                    ...addressInformation,
                                                    permanent_address: e.target.value,
                                                });
                                            } else {
                                                setAddressInformation({
                                                    ...addressInformation,
                                                    permanent_address: '',
                                                });
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div
                            className='flex justifyEnd alignCenter w-100'
                            style={{ height: 64, marginTop: 16 }}
                        >
                            <div className='flex justifyBetween alignCenter'>
                                <div
                                    className='flex justifyEnd alignCenter register_button'
                                    style={{ margin: '0 8px' }}
                                    onClick={() => onUpdate()}
                                >
                                    {loading ? (
                                        <div className='custom_loader' />
                                    ) : (
                                        <h3>{`محفوظ کریں`}</h3>
                                    )}
                                </div>
                                <div
                                    className='flex justifyEnd alignCenter delete_button'
                                    style={{ margin: '0 8px' }}
                                    onClick={() => onClose()}
                                >
                                    <h3>{`منسوخ کریں`}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditTeacherAddressDetailsModal;
